/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Avatar Assets</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5" >
                <div class="row">
                    <div class="form-group col-md-12">
                        <label>Type</label>
                        <select class="form-control mb-4" ref="type">
                            <option value="body">Body</option>
                            <option value="head">Head</option>
                            <option value="hair">Hair</option>
                            <option value="under_hair">Under Hair</option>
                            <option value="hand">Hand</option>
                            <option value="eyes">Eyes</option>
                            <option value="mouth">Mouth</option>
                            <option value="nose">Nose</option>
                            <option value="eyebrows">Eyebrows</option>
                            <option value="glasses">Glasses</option>
                            <option value="polo">Polo</option>
                            <option value="socks">Socks</option>
                            <option value="watchs">Watchs</option>
                            <option value="shirt">Shirt</option>
                            <option value="earrings">Earrings</option>
                            <option value="jackets">Jackets</option>
                            <option value="shoes">Shoes</option>
                            <option value="pants">Pants</option>
                            <option value="necklace">Necklace</option>
                            <option value="backitem">Backitem</option>
                            <option value="wallpaper">Wallpaper</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Price</label>
                        <input type="number" ref="price" id="" class="form-control mb-4" value="0" placeholder="Price">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Gender</label>
                        <select class="form-control mb-4" ref="gender">
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Image</label>
                        <input type="file" ref="file" id="" class="form-control mb-4" accept="image/jpeg, image/png">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Thumb</label>
                        <input type="file" ref="thumb" id="" class="form-control mb-4" accept="image/jpeg, image/png">
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addAvatarAssets()">Add Avatar Assets</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddAvatars',
    components: {

    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        addAvatarAssets() {

            if(this.$refs.thumb.files.length == 0 || this.$refs.file.files.length == 0) {
                this.$toast.open({
                        message: "Error : Please add image and thumbnail",
                        type: 'error'
                    })
                return;
            }

            let data = {
                price: parseInt(this.$refs.price.value),
                type: this.$refs.type.value,
                gender: this.$refs.gender.value,
            }

            var reader = new FileReader()
            reader.readAsDataURL(this.$refs.file.files[0])
            reader.onload = () => {
                data['image'] = reader.result;
                var reader1 = new FileReader()
                reader1.readAsDataURL(this.$refs.thumb.files[0])
                reader1.onload = () => {
                    data['thumb'] = reader1.result;
                    const config = {
                        headers: {
                            Authorization: "Bearer " + this.fastAdminToken,
                            'Content-Type': 'application/json'
                        }
                    }
                    this.$toast.open({
                        message: "Processing : Adding Avatar Assets. Please Wait...",
                        type: 'info'
                    })
                    axios.post(this.$apiURI + "/avatars/create", data, config)
                        .then((response) => {
                            if (response.data.error) {
                                this.$toast.open({
                                    message: "Error : " + response.data.message,
                                    type: 'error'
                                });
                            } else {
                                this.$toast.open({
                                    message: "Avatar Assets Created Successfully",
                                    type: 'success'
                                })
                            }

                        }).catch((error) => {
                            this.$toast.open({
                                message: "Error : " + error.response.data.message,
                                type: 'error'
                            });
                        })
                };
            };

            
        }
    }
}
</script>
